import { render } from "./NamoTermModal.vue?vue&type=template&id=f70b7230"
import script from "./NamoTermModal.vue?vue&type=script&lang=js"
export * from "./NamoTermModal.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src1700309314/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__